var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
export var TallSeparator = styled.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  margin: 0;\n  height: ", "px;\n  border: none;\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  background: ", ";\n  ", ";\n"])), function (props) {
  return props.separatorHeight;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: ", "px;\n    margin-bottom: ", "px;\n  "])), props.verticalMargin, props.verticalMargin);
});
export var Border = styled.hr(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  margin: 0;\n  border: none;\n  height: 1px;\n  background: ", ";\n"])), function (props) {
  return props.backgroundColor;
});
export var InsetBorderContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding-left: ", "px;\n  ", ";\n"])), function (props) {
  return props.inset;
}, function (props) {
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-top: ", "px;\n    margin-bottom: ", "px;\n  "])), props.verticalMargin, props.verticalMargin);
});